import request from '../utils/request'

const commonUrl = '/api/manage'

export function wexonlogin(params) {
  return request.post(`${commonUrl}/authenticate/login`, params)
}

//刷新令牌
export function freshToken() {
  return request.get(`/api/manage/authenticate/refresh`)
}

//homePage
export function getHomePageInfo() {
  return request.get(`${commonUrl}/statistic/`)
}

export function checkConfig(id, value) {
  return request.put(`${commonUrl}/statistic/config/${id}/${value}`)
}

//user
export function getUserList(params) {
  return request.get(`${commonUrl}/user/users`, params)
}

export function userRegister(id) {
  return request.get(`${commonUrl}/user/user/${id}`)
}

export function changeUserStatus(params) {
  return request.put(`${commonUrl}/user/users/is_membership`, params)
}

//banner

export function getBannerList(params) {
  return request.get(`${commonUrl}/banner/banners`, params)
}

export function newBanner(params) {
  return request.post(`${commonUrl}/banner/banner`, params)
}

export function changeBanner(params) {
  return request.put(`${commonUrl}/banner/banner`, params)
}

export function deleteBanner(key) {
  return request.delete(`${commonUrl}/banner/banner/${key}`)
}

//house

export function getHouseList(params) {
  return request.get(`${commonUrl}/rent/houses`, params)
}

export function changeHousePriority(id, value) {
  return request.put(`${commonUrl}/rent/house/${id}/priority/${value}`)
}

export function changeHouseCommand(id, value) {
  return request.put(`${commonUrl}/rent/house/${id}/recommend/${value}`)
}

export function changeHouseCommandAD(id, value) {
  return request.put(`${commonUrl}/rent/house/${id}/recommend_ad/${value}`)
}

export function changeHouseprioritized(id, value) {
  return request.put(`${commonUrl}/rent/house/${id}/prioritized/${value}`)
}

export function changeMultipleHouseState(params) {
  return request.put(`${commonUrl}/rent/house/show`, params)
}

export function newHouse(params) {
  return request.post(`${commonUrl}/rent/house`, params)
}

export function changeHouse(params) {
  return request.put(`${commonUrl}/rent/house`, params)
}

export function deleteHouse(id) {
  return request.delete(`${commonUrl}/rent/house/${id}`)
}

//post

export function getPostList(params) {
  return request.get(`${commonUrl}/forum/thread/threads`, params)
}

export function postDetail(id) {
  return request.get(`${commonUrl}/forum/thread/${id}`)
}

export function changeStickyStatus(params) {
  return request.put(`${commonUrl}/forum/thread/threads/sticky`, params)
}

export function postCheck(params) {
  return request.put(`${commonUrl}/forum/thread/threads/audit`, params)
}

//comment

export function getCommentList(params) {
  return request.get(`${commonUrl}/forum/post/posts`, params)
}

export function getCommentDetail(id) {
  return request.get(`${commonUrl}/forum/post/${id}`)
}

export function commentCheck(params) {
  return request.put(`${commonUrl}/forum/post/posts/audit`, params)
}

//studyShare

export function getShareList(params) {
  return request.get(`${commonUrl}/academic/sharings`, params)
}

export function shareDetail(id) {
  return request.get(`${commonUrl}/academic/sharing/${id}`)
}

export function newShare(params) {
  return request.post(`${commonUrl}/academic/sharing`, params)
}

export function changeShare(params) {
  return request.put(`${commonUrl}/academic/sharing`, params)
}

export function deleteShare(id) {
  return request.delete(`${commonUrl}/academic/sharing/${id}`)
}

export function getCategories(params) {
  return request.get(`${commonUrl}/academic/sharings/categories`, params)
}

export function postCategories(params) {
  return request.post(`${commonUrl}/academic/sharings/category`, params)
}

export function putCategories(params) {
  return request.put(`${commonUrl}/academic/sharings/category`, params)
}

export function deleteCategories(id) {
  return request.delete(`${commonUrl}/academic/sharings/category/${id}`)
}

//administrators
export function getadministrationList(params) {
  return request.get(`${commonUrl}/administer/administrators`, params)
}
export function newAdministratior(params) {
  return request.post(`${commonUrl}/administer/administrator`, params)
}

export function deleteadministratior(id) {
  return request.delete(`${commonUrl}/administer/administrator/${id}`)
}

export function changeadministratior(params) {
  return request.put(`${commonUrl}/administer/administrator`, params)
}
export function changeAdministratiorPSW(params) {
  return request.put(`${commonUrl}/administer/administrator/password`, params)
}

//image
export function uploadImg(params) {
  return request.post(`${commonUrl}/upload/origin`, params)
}

//video
export function uploadVideo(params) {
  return request.post(`${commonUrl}/upload/video`, params)
}

export function deleteVideo(videoUrl, id) {
  return request.delete(
    `${commonUrl}/upload/video/?video=${videoUrl}&house_id=${id}`
  )
}

//获取cos凭证
export function getCOS() {
  return request.get(`${commonUrl}/upload/sts`)
}

//event
export function getSurveyStatus() {
  return request.get(`${commonUrl}/activity/survey`)
}

export function getHomepageFloatStatus(params) {
  return request.get(`${commonUrl}/activity/float_home`, params)
}

export function getHouseFloatStatus(params) {
  return request.get(`${commonUrl}/activity/float_house`, params)
}

export function getSurveyResult(range) {
  return request.get(`${commonUrl}/activity/survey_result/?range=${range}`)
}

export function changeSurveyStatus(params) {
  return request.put(`${commonUrl}/activity/survey`, params)
}

export function changeHomepageFloatStatus(params) {
  return request.put(`${commonUrl}/activity/float_home`, params)
}

export function changeHouseFloatStatus(params) {
  return request.put(`${commonUrl}/activity/float_house`, params)
}

export function getContactTable(params) {
  return request.get(`${commonUrl}/activity/contacts`, params)
}

export function postNewContact(params) {
  return request.post(`${commonUrl}/activity/contact`, params)
}

export function changeContact(params) {
  return request.put(`${commonUrl}/activity/contact`, params)
}

//group
export function getGroup(params) {
  return request.get(`${commonUrl}/grouping/groups`, params)
}

export function postGroup(params) {
  return request.post(`${commonUrl}/grouping/group`, params)
}

export function changeGroup(params) {
  return request.put(`${commonUrl}/grouping/group`, params)
}

export function deleteGroup(id) {
  return request.delete(`${commonUrl}/grouping/group/${id}`)
}

//market
export function getMarketList(params) {
  return request.get(`${commonUrl}/market/items`, params)
}

export function postMarketItem(params) {
  return request.post(`${commonUrl}/market/item`, params)
}

export function changeMarketItem(params) {
  return request.put(`${commonUrl}/market/item`, params)
}

export function deleteMarketItem(id) {
  return request.delete(`${commonUrl}/market/item/${id}`)
}

export function getMarketCategories(params) {
  return request.get(`${commonUrl}/market/categories`, params)
}

export function postMarketCategories(params) {
  return request.post(`${commonUrl}/market/category`, params)
}

export function putMarketCategories(params) {
  return request.put(`${commonUrl}/market/category`, params)
}

export function deleteMarketCategories(id) {
  return request.delete(`${commonUrl}/market/category/${id}`)
}

//rentReadMe
export function getRentReadMe(id) {
  return request.get(`${commonUrl}/home/article/1`)
}

export function changeRentReadMe(params) {
  return request.put(`${commonUrl}/home/article`, params)
}
